import React, { useEffect, useRef } from 'react'
import "./style.css"

const CMMultiScrollableDataTable = ({ children, refresh }) => {
    const scrollSyncRef = useRef();
    const scrollSyncInnerRef = useRef();
    const parentTagRef = useRef();
    useEffect(() => {
        const scrollSync = scrollSyncRef.current;
        const parentTag = parentTagRef.current;
        const scrollSyncInner = scrollSyncInnerRef.current;

        const updateWidths = () => {
            if (scrollSync && parentTag && scrollSyncInner) {
                scrollSyncInner.style.width = `${parentTag.scrollWidth}px`;
            }
        }

        const syncScroll = () => {
            if (scrollSync && parentTag) {
                scrollSync.scrollLeft = parentTag.scrollLeft;
            }
        };

        const syncScrollReverse = () => {
            if (scrollSync && parentTag) {
                parentTag.scrollLeft = scrollSync.scrollLeft;
            }
        };

        updateWidths();

        scrollSync.addEventListener("scroll", syncScrollReverse);
        parentTag.addEventListener("scroll", syncScroll);
        window.addEventListener("resize", updateWidths);

        return () => {
            scrollSync.removeEventListener("scroll", syncScrollReverse);
            parentTag.removeEventListener("scroll", syncScroll);
            window.removeEventListener("resize", updateWidths);
        };
    }, [refresh, children]);

    return (
        <div className="scroll-container">
            <div className="scroll-sync" ref={scrollSyncRef}>
                <div className="scroll-sync-inner" ref={scrollSyncInnerRef}></div>
            </div>
            <div className="parent-tag" ref={parentTagRef}>
                {children}
            </div>
        </div>
    )
}

export default CMMultiScrollableDataTable